<script setup lang="ts">
import IconDoc from "@/assets/svg/document.svg?component"

defineOptions({
  name: "WElCard"
})

withDefaults(defineProps<{ title?: string }>(), {
  title: "标题"
})
</script>

<template>
  <el-card shadow="hover">
    <div class="flex justify-between items-center">
      <div class="flex items-center gap-x-[5px] font-bold text-[14px]">
        <slot name="icon"><IconDoc class="w-[15px]" /></slot>
        <div>{{ title }}</div>
      </div>

      <slot name="action" />
    </div>

    <div class="py-[10px]">
      <slot name="default" />
    </div>
  </el-card>
</template>

<style scoped lang="scss">
:deep(.el-card__body) {
  padding: 10px 15px;
}
</style>
